module.exports = __webpack_public_path__ + "static/img/homePlan2.aeafeab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/homePlan2.png
// module id = kTyU
// module chunks = 3